<div class="modal-header justify-content-center">
    <h4 class="modal-title">{{'NOTIFICATION_TEXT' | translate}}</h4>
</div>
<div class="modal-body">
    <p>{{ 'CAN_NOT_PROCEED' | translate }}</p>
    <p>{{ displayDecisionText }}</p>
    <p *ngIf="processedReason && processedDecision === 'R'">
      Reason: {{ processedReason }}
    </p>
</div>

<div class="modal-footer d-flex justify-content-center">
    <button class="btn btn-primary btn-block primary-btn" (click)="successActionFunc()">{{ 'OK' | translate }}</button>
</div>